
import { defaultTheme, darkTheme, customTheme, themeOptions } from './default';
import { createTheme } from '@material-ui/core';
export default {
  default: createTheme({ ...customTheme}),
  //default: createTheme({...themeOptions})
};